@let _fullScreen = layoutState.canShowFullScreen && (layoutState.fullScreen$ | async);
@let _subscriptionNotificationData = layoutState.subscriptionNotificationData$ | async;
@let _pageHeight = layoutState.pageHeight$ | async;
@let _footerHeight = layoutState.footerHeight$ | async;
@let _isPadding = layoutState.isPadding$ | async;
@let _bannerHeight = (layoutState.bannerHeight$ | async) || 0;

<div class="app-layout__top">
  <app-payment-overdue-banner
    appSize
    (appSize.height)="layoutState.setBannerHeight($event)">
  </app-payment-overdue-banner>

  <div class="app-layout__navbar">
    <app-navbar></app-navbar>
  </div>
</div>

@if (layoutState.showPageLoader()) {
  <div
    class="app-widget-spinner"
    style="position: fixed; z-index: 4"
    [style.top]="layoutState.navbarHeight + layoutState.headerHeight + _bannerHeight + 'px'"></div>
}

<div
  appSize
  (appSize.height)="layoutState.pageHeight$.next($event)"
  class="app-layout__page"
  [style.padding-bottom.px]="_isPadding && _footerHeight ? _footerHeight + 20 : null">
  <div
    [class.app-page-container]="!_fullScreen"
    [class.app-layout__page--full-screen]="_fullScreen">
    @if (_subscriptionNotificationData) {
      <app-subscription-notification
        class="bg-block-main br-6"
        [title]="_subscriptionNotificationData.title"
        [height]="'calc(100vh - 90px)'"
        style="margin-top: 15px">
      </app-subscription-notification>
    }

    @if (!_subscriptionNotificationData) {
      <router-outlet></router-outlet>
    }
  </div>

  <app-copilot-ask-launcher></app-copilot-ask-launcher>
</div>

@if (layoutState.isFooter$ | async) {
  <div
    appSize
    (appSize.height)="layoutState.footerHeight$.next($event)"
    (ngDestroy)="layoutState.footerHeight$.next(0)"
    class="app-layout__footer"
    [style.top.px]="layoutState.navbarHeight + _bannerHeight + _pageHeight">
    <app-footer>
      <ng-container app-footer-links>
        <div class="flex-row g-8">
          <span
            class="b5-r t-not-capitalize cursor-pointer hover-t-underline"
            (click)="_goToTermsOfUse()"
            (mouseup)="_onMouseupToTermsOfUse($event)">
            {{ 'pages.termsOfUse' | translate }}
          </span>

          <span
            class="b5-r t-not-capitalize cursor-pointer hover-t-underline"
            (click)="_goToPrivacyPolicy()"
            (mouseup)="_onMouseupToPrivacyPolicy($event)">
            {{ 'pages.privacyPolicy' | translate }}
          </span>

          <app-site-info-trigger [type]="SiteInfoType.Footer">
            <span class="b5-r cursor-pointer hover-t-underline">
              {{ 'common.disclaimer' | translate }}
            </span>
          </app-site-info-trigger>
        </div>
      </ng-container>

      <ng-container app-footer-copyright>
        <app-site-info-outlet [data]="copyrightData$ | async"></app-site-info-outlet>
      </ng-container>
    </app-footer>
  </div>
}
